import { apiFetch } from '../lib/api';
import { ENDPOINTS } from '../constants/endpoints';

export async function parseDocuments(
  files: File[],
): Promise<{ content: string; fileName: string }[]> {
  const formData = new FormData();
  for (const file of files) {
    formData.append('files', file);
  }

  const response = await apiFetch(ENDPOINTS.PARSE_DOCUMENT, {
    method: 'POST',
    body: formData,
  });

  if (!response.ok) {
    const errorData = await response.json();
    throw new Error(errorData.error || 'Failed to parse documents');
  }

  const { documents } = await response.json();
  return documents;
}
